<script>
export default {
  name: 'RtUploadOrigin',

  methods: {
    clearFiles () {
      this.$refs.upload.clearFiles();
    },
    abort (file) {
      this.$refs.upload.abort(file);
    },
    submit () {
      this.$refs.upload.submit();
    }
  },

  render (h) {
    return h(
      'el-upload',
      {
        class: {
          'rt-upload': true
        },
        attrs: this.$attrs,
        props: this.$props,
        ref: 'upload'
      },
      [this.$slots.default, this.$slots.tip, this.$slots.trigger]
    );
  }
};
</script>



// WEBPACK FOOTER //
// rtUploadOrigin.vue?762e3ee5